import React from "react";
import LoginForm from "../../../components/user-management/login";

export default function LoginPage() {
  return <LoginForm />;
}
